/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import { fetchData, toasterrormsg } from '../../../reusable'
import { Tr } from '../../../_metronic/i18n/Tr'

const AccountHeader: React.FC = () => {

  const location = useLocation()
  let t = Tr()

  //overview states
  const [fullName,setFullName]=useState("");
  const [email,setEmail]=useState("");
  const [profileCompletion,setProfileComoletion]=useState(0)

  //profile state
  const [imageUrl,setImageUrl]=useState("");

  // view profile api call
  const viewprofile=async()=>{
        
    var tmp:any=sessionStorage.getItem("admin")
    tmp=JSON.parse(tmp)
    
    var param:any={
        adminId:String(tmp['adminId']),
    }

    var response:any=await fetchData("admin/viewProfile",param)
    
    if(response.status=="200")
    {
        
        var data=response.data[0]
        
        setFullName(data['fullName']);
        setEmail((data['email']));
        setImageUrl(data['profilePicture'])
        
        var tmpsta:any=0
        if(data['fullName']!=null && data['fullName']!="")
        {
          tmpsta=tmpsta+25
        }
        if(data['email']!=null && data['email']!="")
        {
          tmpsta=tmpsta+25
        }
        if(data['mobileNumber']!=null && data['mobileNumber']!="")
        {
          tmpsta=tmpsta+25
        }
        if(!data['profilePicture'].includes("default.jpg"))
        {
          tmpsta=tmpsta+25
        }
        setProfileComoletion(tmpsta)
        tmp['fullName']=data['fullName']
        tmp['mobile_number']=data['mobileNumber']
        tmp['email']=data['email']
        tmp['profilePicture']=data['profilePicture']
        tmp['country_code']=data['countryCode']

        sessionStorage.setItem("admin",JSON.stringify(tmp))
        
    }
    else
    {
        toasterrormsg(response.message)
        
    }
  }
  useEffect(()=>{
    document.title = 'Insayr | Admin Profile' 
    viewprofile()
    
  },[])
  
  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0'>
        <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
          <div className='me-7 mb-4'>
            <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
              <img src={imageUrl==="" || imageUrl===null?toAbsoluteUrl('/media/default.jpg'):imageUrl} alt='vendor avatar' />
              <div className='position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px'></div>
            </div>
          </div>

          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex align-items-center mb-2'>
                  <a href='#' className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                    {fullName}
                  </a>


                </div>

                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                  >
                    <KTIcon iconName='profile-circle' className='fs-4 me-1' />
                    {t("Admin")}
                  </a>
                 
                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary mb-2'
                  >
                    <KTIcon iconName='sms' className='fs-4 me-1' />
                    {email}
                  </a>
                </div>
              </div>

            </div>

            <div className='d-flex flex-wrap flex-stack'>


              <div className='d-flex align-items-center w-200px w-sm-300px flex-column mt-3'>
                <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
                  <span className='fw-bold fs-6 text-gray-400'>{t("Profile Compleation")}</span>
                  <span className='fw-bolder fs-6'>{profileCompletion}%</span>
                </div>
                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                  <div
                    className='bg-success rounded h-5px'
                    role='progressbar'
                    style={{width: profileCompletion+"%"}}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/profile/overview' && 'active')
                }
                to='../overview'
              >
                {t("Overview")}
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/profile/settings' && 'active')
                }
                to='../settings'
              >
                {t("Settings")}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export {AccountHeader}
